export enum Steps {
  SHIPPING_METHOD = 1,
  SELECT_INVENTORY = 2,
  SELECT_PRODUCTS = 3,
  CART = 4,
  SIGN_UP = 5,
  METHODS_PAYMENTS = 6,
  PAYMENT_DETAILS = 7,
  COMPLETED = 8,
  START_ORDER = 9,
}

export const conversationSteps: {
  name: string;
  value: Steps;
  label: string;
  description: string;
  icon: string;
}[] = [
  {
    name: 'SHIPPING_METHOD',
    value: Steps.SHIPPING_METHOD,
    label: 'Método de envío',
    description:
      'Se le mandan los botones y el usuario debe seleccionar si quiere delivery o pickup',
    icon: 'fa-truck',
  },
  {
    name: 'SELECT_INVENTORY',
    value: Steps.SELECT_INVENTORY,
    label: 'Sede',
    description: 'Si existe la opción de escoger más de una sede',
    icon: 'fa-warehouse',
  },
  {
    name: 'SELECT_PRODUCTS',
    value: Steps.SELECT_PRODUCTS,
    label: 'Seleccionando productos',
    description: 'El usuario escoge productos',
    icon: 'fa-boxes',
  },
  {
    name: 'CART',
    value: Steps.CART,
    label: 'Carrito',
    description:
      'El usuario se le envía el carrito de compra para seguir con el pedido',
    icon: 'fa-shopping-cart',
  },
  {
    name: 'SIGN_UP',
    value: Steps.SIGN_UP,
    label: 'Registro',
    description:
      'Si no se ha registrado, se le manda el flujo para el registro',
    icon: 'fa-user-plus',
  },
  {
    name: 'METHODS_PAYMENTS',
    value: Steps.METHODS_PAYMENTS,
    label: 'Métodos de pago',
    description: 'Se le mandan los métodos de pago',
    icon: 'fa-credit-card',
  },
  {
    name: 'PAYMENT_DETAILS',
    value: Steps.PAYMENT_DETAILS,
    label: 'Detalles de pago',
    description: 'Se le manda la información para realizar el pago',
    icon: 'fa-file-invoice-dollar',
  },
  {
    name: 'COMPLETED',
    value: Steps.COMPLETED,
    label: 'Pedido completado',
    description: 'El pedido ha sido completado',
    icon: 'fa-check',
  },
  {
    name: 'START_ORDER',
    value: Steps.START_ORDER,
    label: 'Inicio',
    description: 'Inicio del pedido',
    icon: 'fa-play',
  },
];
